import { sendGTMEvent } from '@next/third-parties/google'

const signalEvent = (message: string, event: string = 'custom_action') => {
  sendGTMEvent({ event, value: message })
}

export default {
  signalEvent,
}
